import '@/presentation/assets/styles/global-scrollbar.css'
import '@/presentation/assets/styles/index.css'
import '@/presentation/assets/styles/accessibility.css'
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import './i18n'
import ErrorMonitor from './infra/tracking/error-monitor'
import { launchDarklyConfig } from './infra/feature-flag'
import Router from './main/routes/router'

ErrorMonitor.startMonitoring()

const renderApp = async () => {
  const LDProvider = await asyncWithLDProvider(launchDarklyConfig)

  const root = ReactDOM.createRoot(document.getElementById('root')!)

  root.render(
    <StrictMode>
      <LDProvider>
        <Router />
      </LDProvider>
    </StrictMode>
  )
}

renderApp()
